import React from "react";
import PropTypes from "prop-types";
import Timestamp from "../../ui/Timestamp";
import { DateTime } from "luxon";
import styled from "styled-components";
import connectedIcon from "../../icons/icon-signal-connected.svg";
import diconnectedIcon from "../../icons/icon-signal-disconnected.svg";
import weakIcon from "../../icons/icon-signal-weak.svg";

const calculateBehindBySecs = (lastUpdated) => {
	if (lastUpdated) {
		const now = DateTime.now().toUTC().toSeconds();
		const lu = DateTime.fromISO(lastUpdated).toUTC().toSeconds();
		const lagInSecs = now - lu;

		let status = statusesInfo["disconnected"];
		const statuses = Object.values(statusesInfo);
		for (let i = 0; i < statuses.length; i++) {
			if (lagInSecs <= statuses[i].maxBehindBySecs) {
				status = statuses[i];
				break;
			}
		}

		return status;
	}
};

/** Status  */
const StatusContainer = styled.span`
  color: ${(props) => props.color};
`;

const Icon = styled.div`
  flex: none;
  width: 100%;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
`;

const ImageIcon = styled(Icon)`
  background-position: right;
  background-size: 1.25rem;
  background-repeat: no-repeat;
`;

const ConnectedIcon = styled(ImageIcon)`
  background-image: url(${connectedIcon});
`;

const DisconnectedIcon = styled(ImageIcon)`
  background-image: url(${diconnectedIcon});
`;

const WeakIcon = styled(ImageIcon)`
  background-image: url(${weakIcon});
`;

const statusesInfo = {
	connected: {
		color: "green",
		text: "connected",
		icon: <ConnectedIcon />,
		maxBehindBySecs: 120,
	},
	weak: {
		color: "orange",
		text: "possible connectivity issues",
		icon: <WeakIcon />,
		maxBehindBySecs: 240,
	},
	disconnected: {
		color: "red",
		text: "disconnected",
		icon: <DisconnectedIcon />,
		maxBehindBySecs: Infinity,
	},
};

const AstrositeStatus = ({
	astrosite = {},
	advancedMode = false,
	hideLastUpdated = false,
	showStatusText = false,
	showIcon = false,
}) => {
	const status = calculateBehindBySecs(astrosite.lastUpdated);
	return (
		<div>
			{astrosite?.lastUpdated && (
				<StatusContainer
					color={status.color}
					title={`last updated: ${astrosite.lastUpdated}`}
				>
					{showIcon && <span>{status.icon}</span>}
					{showStatusText && <span>{status.text}</span>}
					{!hideLastUpdated && astrosite?.lastUpdated && (
						<div>
							Updated at{" "}
							<Timestamp utc={advancedMode}>{astrosite.lastUpdated}</Timestamp>
						</div>
					)}
				</StatusContainer>
			)}
			{!astrosite?.lastUpdated && (
				<StatusContainer color="red" title={`last updated: offline`}>
					{showIcon && <DisconnectedIcon />}
					{showStatusText && <span>offline</span>}
				</StatusContainer>
			)}
		</div>
	);
};

AstrositeStatus.propTypes = {
	astrosite: PropTypes.object,
	advancedMode: PropTypes.bool,
	hideLastUpdated: PropTypes.bool,
	showStatusText: PropTypes.bool,
	showIcon: PropTypes.bool,
};

export default AstrositeStatus;
